import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { SettingsContainer } from "../../components/molecules/settingsContainer";
import { ClipSettingsBody } from "MVVM/Components/ClipSettingsModal/ClipSettingsBody";
import { useCs2HudSettingsModal } from "MVVM/Hooks/useClipQualitySettingsModal";

export function ClipSettings() {
  const { search } = useLocation();
  const { open: openCs2Hud } = useCs2HudSettingsModal();

  // /clip-settings?import opens the CS2 modal straight onto the import tab.
  useEffect(() => {
    if (new URLSearchParams(search).has("import")) openCs2Hud("IMPORT");
  }, [search, openCs2Hud]);

  return (
    <SettingsContainer
      title="Clip Settings"
      subtitle="Manage how your clips are captured, saved, and rendered"
      mb={5}
    >
      <ClipSettingsBody source="clip-settings-page" />
    </SettingsContainer>
  );
}
